import React, { useEffect, useState, useContext } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar';
import { UserContext } from './UserContext';
import * as XLSX from 'xlsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function LeanReport() {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const formatDate = (data) => {
  if (data) {
    let msDate = data;
    let timestamp = parseInt(msDate.match(/\d+/)[0], 10);
    let date = new Date(timestamp);

    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear(); // full year

    return `${day}-${month}-${year}`;
  } else {
    return "";
  }
};

function parseSapDate(sapDate) {
    // Match /Date(1234567890)/ or /Date(1234567890+0000)/
    const match = /\/Date\((\d+)(?:[+-]\d+)?\)\//.exec(sapDate);
    if (match) {
        const timestamp = parseInt(match[1], 10); // milliseconds
        const date = new Date(timestamp);
        // Format as dd-mm-yyyy
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    } else {
        // Fallback: try normal date parsing
        const date = new Date(sapDate);
        if (!isNaN(date)) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        }
    }
    return sapDate; // return original if parsing fails
}

  const { userData } = useContext(UserContext);
  const [prData, setPrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());

  // Inside the component, after state declarations

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  const searchRecords = async () => {
    setLoading(true);
    try {
      let fromDate = new Date(selectedFromDate).toLocaleDateString("en-GB").replace(/\//g, "-");
      let toDate = new Date(selectedToDate).toLocaleDateString("en-GB").replace(/\//g, "-");
      const response = await axios.get(baseUrl + "auth/getMiro", {
        params: {
          user_id: userId,
          fromDate: fromDate,
          toDate: toDate
        },
        ...config
      });
      //console.log(response.data.data); return false;
      const data = response.data?.data || [];
      setPrData(data);
    } catch (error) {
      //console.log(error.response.data.error);
      if (error.response.data.error === "login_required" && error.response.data.login_url) {
        //console.log("here"); return false;
        window.location.href = error.response.data.login_url;
        //console.log(data.login_url);
      }
      else {
        setPrData([]);
      }
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };


  const userTypeLabels = {
  "0": "NA",
  "1": "EIC",
  "2": "Director DP",
  "3": "Director HR",
  "4": "VP Finance",
  "5": "Super Admin",  
};

  useEffect(() => {
    const fetchPRs = async () => {
      setLoading(true);
    try {
      let fromDate = new Date(selectedFromDate).toLocaleDateString("en-GB").replace(/\//g, "-");
      let toDate = new Date(selectedToDate).toLocaleDateString("en-GB").replace(/\//g, "-");
      const response = await axios.get(baseUrl + "auth/getLeanSheet", {
        params: {
          user_id: userId
        },
        ...config
      });
      //console.log(response.data.data); return false;
      //const data = response.data?.data || [];
      const data = response.data?.data.filter((item) => item.ApprovalStatus!=10) || [];

      setPrData(data);
    } catch (error) {
      //console.log(error.response.data.error);
      if (error.response.data.error === "login_required" && error.response.data.login_url) {
        //console.log("here"); return false;
        window.location.href = error.response.data.login_url;
        //console.log(data.login_url);
      }
      else {
        setPrData([]);
      }
    } finally {
      setLoading(false);
    }
    };

    fetchPRs();
  }, []);

  useEffect(() => {
    const lower = searchText.toLowerCase();
    const filteredData = prData.filter(pr => {
      const ServiceEntrySheet = pr.ServiceEntrySheet?.toLowerCase() || '';
      const Supplier = pr.Supplier?.toLowerCase() || '';
      return (
        ServiceEntrySheet.includes(lower) ||
        Supplier.includes(lower)
            );
    });

    setFiltered(filteredData);
  }, [searchText, prData]);

  const columns = [
  {
    name: '#',
    cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
    width: '60px',
  },
  { name: 'Service Entry Sheet', selector: (row) => row.ServiceEntrySheet, sortable: false },
  { name: 'Purchasing Organization', selector: (row) => row.PurchasingOrganization },
  { name: 'Purchase Order', selector: (row) => row.PurchaseOrder },
  { name: 'Supplier', selector: (row) => row.Supplier },
  { name: 'Creation Date', selector: (row) => formatDate(row.CreationDateTime) },
  { name: 'Last Change Date', selector: (row) => formatDate(row.LastChangeDateTime) },
  { name: 'Posting Date', selector: (row) => formatDate(row.PostingDate) },
  {
    name: 'Action',
    cell: (row) => (
      <button
          onClick={() => navigate(`/lean-details/${row.ServiceEntrySheet}`)}
          style={{
            padding: '5px 10px',
            border: 'none',
            background: '#007bff',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          View Details
        </button>
    ),
  },
];


  return (
    <>
      <Topbar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">Lean LIST</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                  <li className="breadcrumb-item active">Lean List</li>
                </ol>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div>
                     <input
                      type="text"
                      placeholder="Search.."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{
                        width: '30%',
                        padding: '10px',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                        float: 'right'
                      }}
                    />
                  </div>


                  <DataTable
                    columns={columns}
                    data={filtered}
                    pagination
                    paginationServer={false}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={filtered.length}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={loading}
                    progressComponent={<div style={{color:"green", fontSize: "35px"}}>Loading Lean List....</div>}
                    highlightOnHover
                    persistTableHead
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right sidebar left as-is */}
        </div>
      </div>
    </>
  );
}